import { motion } from 'framer-motion'
import styled from 'styled-components'
import DailyTypeMoon from './DailyTypeMoon'

const PersonalContainer = styled.section`
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 80px 24px;
    position: relative;
    z-index: 2;
    box-sizing: border-box;

    @media (max-width: 768px) {
        padding: 60px 20px;
        min-height: auto;
        padding-top: 80px;
        padding-bottom: 80px;
    }

    @media (max-width: 480px) {
        padding: 50px 16px;
    }
`

const ContentWrapper = styled(motion.div)`
    max-width: 600px;
    width: 100%;
    text-align: center;
    padding: 0;

    @media (max-width: 768px) {
        max-width: 100%;
    }
`

const Quote = styled.p`
    font-size: 0.8rem;
    line-height: 1.8;
    color: rgba(255, 255, 255, 0.6);
    font-weight: 400;
    letter-spacing: 1.5px;
    position: relative;
    margin: 24px 0 32px;

    @media (max-width: 768px) {
        font-size: 0.75rem;
        margin: 20px 0 28px;
        letter-spacing: 1px;
    }
`

const LinksContainer = styled(motion.div)`
    display: flex;
    justify-content: center;
    gap: 30px;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        gap: 20px;
    }
`

const SiteLink = styled(motion.a)`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 16px 32px;
    color: rgba(255, 255, 255, 0.75);
    text-decoration: none;
    font-weight: 500;
    font-size: 0.85rem;
    letter-spacing: 2px;
    text-transform: uppercase;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    border: 1px solid rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(4px);

    &:hover {
        color: rgba(255, 255, 255, 0.95);
        border-color: rgba(255, 255, 255, 0.3);
        background: rgba(255, 255, 255, 0.08);
        transform: translateY(-2px);
    }

    @media (max-width: 768px) {
        padding: 14px 28px;
        font-size: 0.8rem;
        letter-spacing: 1.5px;
        gap: 8px;
    }

    @media (max-width: 480px) {
        padding: 12px 24px;
        font-size: 0.75rem;
        width: 100%;
        max-width: 280px;
    }
`

const LinkIcon = styled.span`
    font-size: 0.9rem;
    opacity: 0.8;
    transition: transform 0.3s ease;

    ${SiteLink}:hover & {
        transform: translateX(3px);
    }

    @media (max-width: 768px) {
        font-size: 0.85rem;
    }
`

const Divider = styled(motion.div)`
    width: 50px;
    height: 1px;
    background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.25),
        transparent
    );
    margin: 28px auto;

    @media (max-width: 768px) {
        width: 40px;
        margin: 24px auto;
    }
`

// 站点链接数据
const siteLinks = [
    {
        name: 'Explore my blog',
        url: 'https://aoko.im',
        // icon: '→'
    }
]

const PersonalSection = () => {
    return (
        <PersonalContainer>
            <ContentWrapper
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
            >
                {/* Daily Type-Moon 每日图片区块 */}
                <DailyTypeMoon />
                
                <Divider
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    viewport={{ once: true }}
                />

                <Quote>
                    Made by Mio for my Princess Arcueid
                </Quote>

                <LinksContainer
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    viewport={{ once: true }}
                >
                    {siteLinks.map((link, index) => (
                        <SiteLink
                            key={link.name}
                            href={link.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            whileHover={{
                                scale: 1.05,
                                transition: { duration: 0.2 }
                            }}
                            whileTap={{ scale: 0.95 }}
                            style={{
                                animationDelay: `${index * 0.1}s`
                            }}
                        >
                            {/* <LinkIcon>{link.icon}</LinkIcon> */}
                            {link.name}
                        </SiteLink>
                    ))}
                </LinksContainer>
            </ContentWrapper>
        </PersonalContainer>
    )
}

export default PersonalSection